import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useState } from 'react';
import { CardBody } from 'reactstrap';

const hexToRGBA = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const generateAssessmentDraftDiscussionOptions = (
  responseData,
  yAxisTitle,
  xAxisTitle,
  color = '#B7D0F6',
) => {
  const categories = Object.keys(responseData); // Dates as categories (or map to Week 1, Week 2, etc.)
  const values = Object.values(responseData);

  const data = values.map((val, i) => ({
    y: val,
    color: {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        [0, hexToRGBA(color, 1)],
        [1, hexToRGBA(color, 0.3)],
      ],
    },
  }));

  return {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: { text: null },
    xAxis: {
      categories,
      crosshair: true,
      title: { text: xAxisTitle },
    },
    yAxis: {
      min: 0,
      max: 100,
      tickInterval: 20,
      title: { text: yAxisTitle },
      labels: {
        formatter: function () {
          return this.value + '%';
        },
      },
    },
    legend: { enabled: false },
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          color: 'black',
          style: { fontSize: '10px', fontWeight: 'bold' },
          verticalAlign: 'middle',
          align: 'left',
          crop: false,
          overflow: 'none',
          x: 10,
          formatter: function () {
            return this.y + '%';
          },
        },
      },
    },
    series: [
      {
        name: 'Assessment Draft Discussion',
        colorByPoint: true,
        data,
      },
    ],
    credits: { enabled: false },
    exporting: {
      enabled: true,
      chartOptions: {
        title: {
          text: 'Assessment Draft Discussion',
        },
      },
    },
  };
};

const ClarityScoreChart = ({
  options,
  yAxisTitle = " Avg clarity score ",
  xAxisTitle = '',
}) => {
  const [
    assessmentDraftDiscussionOptions,
    setassessmentDraftDiscussionOptions,
  ] = useState(null);
  useEffect(() => {
    setassessmentDraftDiscussionOptions(
      generateAssessmentDraftDiscussionOptions(options, yAxisTitle, xAxisTitle),
    );
  }, [options]);

  if (!options || !assessmentDraftDiscussionOptions) return;

  return (
    <>
      <CardBody>
        <div className="">
          <h5 className="f-16 bold d-flex align-items-center mb-3">
         Clarity Score
          </h5>
          <HighchartsReact
            highcharts={Highcharts}
            options={assessmentDraftDiscussionOptions}
          />
        </div>
      </CardBody>
    </>
  );
};

export default ClarityScoreChart;
